import { SlugFilters } from '@utils/slugGenerator';
import { FILTER_TYPE_PRIORITY } from '@utils/filterTypeUtils';
import { getFilterValues } from '@utils/filtersCached';
import { getCurrentSlugFiltersServer } from './server/browseCardServerHelpers';

export const getFilterTypeKey = (filterType: string): keyof SlugFilters | undefined => {
  const typeMap: Record<string, keyof SlugFilters> = {
    'brand': 'brand',
    'bodyType': 'bodyType',
    'fuelType': 'fuelType',
    'transmission': 'transmission',
    'seatingCapacity': 'seatingCapacity',
    'budget': 'budget'
  };
  
  return typeMap[filterType];
};

export const generateFilterValue = (filterType: string, filterValue: string): string => {
  return filterValue.toLowerCase();
};

export const buildSlugFromFilters = (filters: SlugFilters): string => {
  const slugParts: string[] = [];
  
  FILTER_TYPE_PRIORITY.forEach(filterType => {
    const value = filters[filterType];
    if (value) {
      if (Array.isArray(value)) {
        slugParts.push(...value);
      } else {
        slugParts.push(value);
      }
    }
  });
  
  if (slugParts.length === 0) {
    return 'all-cars';
  }
  
  return `${slugParts.join('+')}+cars/`;
};

export const parseSlugToFilters = (slug: string): SlugFilters => {
  if (slug === 'all-cars') {
    return {};
  }

  const filterPart = slug.replace(/[+-]cars\/?$/, '');
  const filterValues = filterPart.split('+');
  
  const filters: SlugFilters = {};
  
  filterValues.forEach(value => {
    const lowerValue = value.toLowerCase();
    
    if (isLikelyBrand(lowerValue)) {
      filters.brand = lowerValue;
    }
    else if (isLikelyBodyType(lowerValue)) {
      filters.bodyType = lowerValue;
    }
    else if (isLikelyFuelType(lowerValue)) {
      filters.fuelType = lowerValue;
    }
    else if (isLikelyTransmission(lowerValue)) {
      filters.transmission = lowerValue;
    }
    else if (isLikelyBudget(lowerValue)) {
      filters.budget = lowerValue;
    }
    else if (isLikelySeatingCapacity(lowerValue)) {
      filters.seatingCapacity = lowerValue;
    }
  });
  
  return filters;
};

export const isLikelyBrand = (value: string): boolean => {
  return getFilterValues().brandValues.includes(value);
};

export const isLikelyBodyType = (value: string): boolean => {
  return getFilterValues().bodyTypeValues.includes(value);
};

export const isLikelyFuelType = (value: string): boolean => {
  return getFilterValues().fuelTypeValues.includes(value);
};

export const isLikelyTransmission = (value: string): boolean => {
  return getFilterValues().transmissionValues.includes(value);
};

export const isLikelySeatingCapacity = (value: string): boolean => {
  return getFilterValues().seatingCapacityValues.includes(value);
};

export const isLikelyBudget = (value: string): boolean => {
  return getFilterValues().budgetValues.includes(value);
};

export const getCurrentFilters = (pathname: string): SlugFilters => {
  return getCurrentSlugFiltersServer(pathname);
};